module.exports = __webpack_public_path__ + "static/media/climate_agriculture_1_precipitation.330a9c4d.jpg";